import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import styled from "styled-components";
import Sidebar from "../../layouts/main/sidebar";
import store from "../../store";
import { validatePassword } from "../../utils/shared.utils";
import "./changePassword.scss";

const ErrorMsg = styled.div`
  margin-top: 1rem;
  color: #b00020;
`;
const SuccessMsg = styled.div`
  margin-top: 1rem;
  color: #2e7d32;
`;

const ChangePassword: React.FC = () => {
  const [password, setPassword] = useState("");
  const [passwordMatch, setPasswordMatch] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showPasswordMatch, setShowPasswordMatch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const token = localStorage.getItem("clientToken") || "";

  const validatePasswordChange = (): boolean => {
    setSuccessMsg("");
    setErrorMsg("");

    if (!password) {
      setErrorMsg("Шинэ нууц үг оруулна уу");
      return false;
    }
    if (!validatePassword(password)) {
      setErrorMsg(
        "Нууц үг 8 тэмдэгтээс урт, ядаж нэг тоо агуулсан, дор хаяж нэг том үсэгтэй байх хэрэгтэй"
      );
      return false;
    }
    if (password !== passwordMatch) {
      setErrorMsg("Дахин оруулсан нууц үг өөр байна");
      return false;
    }
    return true;
  };

  const changePassword = async () => {
    if (!validatePasswordChange()) {
      return;
    }

    setErrorMsg("");
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}new-password`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          newPassword: password,
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.errorMsg || "Алдаа гарлаа");
      }

      setSuccessMsg("Шинэ нууц үг хадгалагдлаа");
      setPassword("");
      setPasswordMatch("");
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      setErrorMsg((err as Error).message || "Сүлжээнд алдаа гарлаа");
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("clientToken");
    store.dispatch({ type: "logout" });
  };
  const closeMenu = () => {};

  return (
    <div className="password-layout page margin-top-50">
      <Sidebar onLogout={logout} closeMenu={closeMenu} />
      <div className="password-container">
        <h3>Нууц үг солих</h3>
        <div className="password-row">
          <div className="password">
            <label className="sm-grey-text">Шинэ нууц үг</label>
            <div className="password-input-wrapper">
              <input
                type={showNewPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
              <span
                className="eye-icon"
                onClick={() => setShowNewPassword((v) => !v)}
              >
                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>

          <div className="password">
            <label className="sm-grey-text">Шинэ нууц үг баталгаажуулах</label>
            <div className="password-input-wrapper">
              <input
                type={showPasswordMatch ? "text" : "password"}
                value={passwordMatch}
                onChange={(e) => setPasswordMatch(e.target.value)}
                disabled={loading}
              />
              <span
                className="eye-icon"
                onClick={() => setShowPasswordMatch((v) => !v)}
              >
                {showPasswordMatch ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>
        </div>

        {errorMsg && <ErrorMsg>{errorMsg}</ErrorMsg>}
        {successMsg && <SuccessMsg>{successMsg}</SuccessMsg>}

        <button
          type="button"
          className="password-button"
          onClick={changePassword}
          disabled={loading}
        >
          {loading ? "Уншиж байна..." : "Хадгалах"}
        </button>
      </div>
    </div>
  );
};

export default ChangePassword;
